namespace advisorop.domains {
    "use strict";

    export interface IMeetingAvailabilityTime {
        startTime?: Date;

        endTime?: Date;
    }

    export interface IMeetingAvailabilityDay {
        date?: Date;

        times?: Array<IMeetingAvailabilityTime>
    }

    export interface IMeetingAvailabilityDuration {
        duration?: number;

        days?: Array<IMeetingAvailabilityDay>;
    }
}